
import EnhancedEquipmentOverview from "./EnhancedEquipmentOverview";

const EquipmentOverview = () => {
  return <EnhancedEquipmentOverview />;
};

export default EquipmentOverview;
